import React from 'react';
import { Apple } from 'lucide-react';
import { LANDING } from '@/constants/testIds';

export const FinalCta = () => {
    return (
        <section
            data-testid={LANDING.finalCtaSection}
            className="relative py-28 sm:py-36 overflow-hidden"
        >
            <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
                <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-[0.98] mb-6">
                    Ready to train
                    <br />
                    <span className="text-[#b8ff00]">smarter?</span>
                </h2>
                <p className="text-base sm:text-lg text-[#8e8e93] mb-10 max-w-xl mx-auto">
                    HyperTroop.Fit is free to download on iPhone. No subscription
                    hidden behind your first set.
                </p>

                <a
                    href="https://apps.apple.com/in/app/hypertroop-fit/id6771863680"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={LANDING.finalCtaBtn}
                    className="btn-primary-lime inline-flex items-center gap-2.5 px-8 py-4 rounded-full text-base font-bold"
                >
                    <Apple size={20} fill="currentColor" />
                    Get it on the App Store
                </a>

                <div className="mt-8 text-xs text-[#8e8e93] uppercase tracking-[0.2em]">
                    iPhone · iOS 16+ · Metric & Imperial
                </div>
            </div>
        </section>
    );
};

export default FinalCta;
